/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  AgencyDropdown,
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  BranchDropDown,
  FormDatePicker,
  FormInput,
  LoadingComponent,
  MoreOptions,
  PreviewCard,
  ReactDataTable,
  StatusActiveDropDown,
  ReportStatusDropdown,
} from "../../../../components/Component";
import Content from "../../../../layout/content/Content";
import Head from "../../../../layout/head/Head";
import {
  HospitalTableData,
  exportClientAPI,
  exportClientProgressReportAPI,
  listHospitalAPI,
} from "./HospitalTableData";
import { PER_PAGE_ITEMS, ServerStatusType } from "../../../../utils";
import AddNotes from "../../notes/AddNote";
import { NoteUserType } from "../../notes/NoteList";
import { ImportExportButton } from "../../../../components/button/ActionButton";
import ImportFileModal from "../../../../components/ImportFileModal/ImportFileModal";
import SendEmailModal from "../../invoices/invoiceEmail/SendEmailModal";
import {
  UserActionType,
  UserPermissionType,
  isAllowToAccess,
  isCheckToList,
} from "../../../../services/permission/permission";
import { openLinkInNewTab, scrollToTop } from "../../../../utils/Functions";
import HospitalHomeCareDropDown from "../../../../components/dropdowns/HospitalHomeCareDropDown";
import {
  ClientTypeDropdownOptions,
  parseUrlParams,
  removeWhitespace,
  statusOptions,
  ReportStatusTypes,
  updateHash,
  useAgencyData,
  useBranchData,
} from "../../../../utils/Utils";
import moment from "moment";

const formatMonthParam = (date) => moment(date).startOf("month").format("YYYY-MM-DD");

const HospitalList = () => {
  const location = useLocation();
  const history = useHistory();

  // Report routes reuse this list with progress-report columns/filters
  const isActiveClientsReport = location.pathname.includes("/reports/active-clients");
  const isReportRoute = location.pathname.includes("/reports/clients") || isActiveClientsReport;
  const reportListPath = isActiveClientsReport
    ? `${process.env.PUBLIC_URL}/reports/active-clients/reports-list`
    : `${process.env.PUBLIC_URL}/reports/clients/reports-list`;
  const pageTitle = isActiveClientsReport ? "Active Clients" : "Clients";
  const [hospitalList, setHospitalList] = useState([]);
  const [status, setStatus] = useState();
  const [progressStatus, setProgressStatus] = useState();
  const [clientType, setClientType] = useState();
  const [branch, setBranch] = useState();
  const [agency, setAgency] = useState({
    id: 0,
    label: "All Agency",
    value: "",
  });
  const [searchText, setSearchText] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [month, setMonth] = useState("");
  const [selectedItem, setSelectedItem] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState();
  const [initScreen, setInitScreen] = useState(true);
  const [totalItems, setTotalItems] = useState(0);
  const [noteModal, setNoteModal] = useState(false);
  const [emailModal, setEmailModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [sortId, setSortId] = useState();
  const [sortOrder, setSortOrder] = useState("asc");
  const emailList = selectedRows?.map((person) => person?.personFields?.map((item) => item?.personEmail));
  const isRowSelected = selectedRows?.length > 0;
  const selectedRowIds = selectedRows.map((row) => row);
  const updatedAgencyData = useAgencyData();
  const updatedBranchData = useBranchData();
  // Active Clients: show/send current month by default without writing it into URL state
  const activeClientsMonth = formatMonthParam(new Date());
  const requestMonth = isActiveClientsReport ? month || activeClientsMonth : month || null;
  const pickerMonth = selectedMonth || (isActiveClientsReport ? moment(activeClientsMonth, "YYYY-MM-DD").toDate() : null);

  useEffect(() => {
    if (!currentPage) return;
    loadHospital();
  }, [currentPage]);
  useEffect(() => {
    if (initScreen) return;
    if (currentPage === 1) {
      loadHospital();
    } else {
      setCurrentPage(1);
    }
  }, [status, progressStatus, searchText, clientType, agency, sortId, sortOrder, branch, isReportRoute, isActiveClientsReport, month]);
  useEffect(() => {
    const params = parseUrlParams();
    if (params.branch && !isActiveClientsReport) {
      const selectedBranch = updatedBranchData.find(
        (option) => removeWhitespace(option.value) === removeWhitespace(params.branch),
      );
      if (selectedBranch && selectedBranch.value !== branch?.value) {
        setBranch(selectedBranch);
      }
    }
    if (params.clientType) {
      const selectedClientType = ClientTypeDropdownOptions.find(
        (option) => removeWhitespace(option.value) === removeWhitespace(params.clientType),
      );
      if (selectedClientType && selectedClientType.value !== clientType?.value) {
        setClientType(selectedClientType);
      }
    }
    if (params.agency) {
      const selectedAgency = updatedAgencyData.find(
        (option) => removeWhitespace(option.value) === removeWhitespace(params.agency),
      );
      if (selectedAgency && selectedAgency.value !== agency?.value) {
        setAgency(selectedAgency);
      }
    }

    // Read status for regular route
    if (!isReportRoute && params.status) {
      const selectedStatus = statusOptions.find(
        (option) => removeWhitespace(option.value) === removeWhitespace(params.status),
      );
      if (selectedStatus && selectedStatus.value !== status?.value) {
        setStatus(selectedStatus);
      }
    }

    // Read progressStatus for report route (only use progressStatus parameter, ignore status)
    if (isReportRoute && params.progressStatus) {
      const selectedProgressStatus = ReportStatusTypes.find(
        (option) => removeWhitespace(option.value) === removeWhitespace(params.progressStatus),
      );
      if (selectedProgressStatus && selectedProgressStatus.value !== progressStatus?.value) {
        setProgressStatus(selectedProgressStatus);
      }
    }
    if (params.search) {
      const searchQuery = decodeURIComponent(params.search);
      setSearchText(searchQuery);
    }
    if (params.month) {
      const monthDate = moment(params.month, "YYYY-MM-DD").toDate();
      setSelectedMonth(monthDate);
      setMonth(formatMonthParam(monthDate));
    } else {
      setSelectedMonth(null);
      setMonth("");
    }
    if (params.page) {
      setCurrentPage(parseInt(params.page, 10));
    } else {
      setCurrentPage(1);
    }
  }, [location]);
  useEffect(() => {
    if (location?.state?.isMoveClientList && location?.state?.status) {
      setStatus(location?.state?.status);
    }
  }, [location?.state?.isMoveClientList, location?.state?.status]);
  const onEdit = (row) => {
    setSelectedItem(row);
    history.push({
      pathname: `${process.env.PUBLIC_URL}/add-client`,
      state: {
        data: row.id,
      },
    });
  };
  const onView = (row) => {
    setSelectedItem(row);
    if (isReportRoute && !isActiveClientsReport) {
      // Get current URL parameters to preserve filters when navigating back
      const currentParams = parseUrlParams();
      const preservedFilters = {
        clientType: currentParams.clientType,
        progressStatus: currentParams.progressStatus,
        status: currentParams.status,
        branch: currentParams.branch,
        agency: currentParams.agency,
        search: currentParams.search,
        month: currentParams.month,
        page: currentParams.page,
      };

      // Set URL hash with clientId and clientName before navigation
      updateHash({
        pathname: reportListPath,
        clientId: row.id,
        clientName: row.name,
      });
      // Navigate to report list page when on reports route
      history.push({
        pathname: reportListPath,
        state: {
          data: row.id,
          clientName: row.name,
          preservedFilters: preservedFilters, // Pass filters to preserve on back navigation
        },
      });
    } else {
      // Navigate to client detail page for regular route / Active Clients
      history.push({
        pathname: `${process.env.PUBLIC_URL}/client-detail`,
        state: {
          data: row.id,
        },
      });
    }
  };
  const loadHospital = () => {
    scrollToTop();
    if (isCheckToList(UserPermissionType.client)) {
      const params = {
        status: isActiveClientsReport
          ? null
          : isReportRoute
            ? ServerStatusType.active
            : (status?.value ?? location.state?.status?.value ?? ServerStatusType.active),
        search: searchText,
        pageInfo: {
          pageIndex: currentPage,
          itemsPerPage: PER_PAGE_ITEMS,
        },
        branchId: isActiveClientsReport ? null : (branch?.id ?? null),
        clientType: clientType?.value ?? null,
        agencyId: agency?.id ?? null,
        month: requestMonth,
        sorting: {
          field: sortId ?? null,
          order: sortOrder ?? null,
        },
      };
      if (isReportRoute) {
        params.isReportGenerated = true;
        if (!isActiveClientsReport) {
          params.progressStatus = progressStatus?.value ?? null;
        }
      }
      if (isActiveClientsReport) {
        params.rotaStatuses = ["ACTIVE", "COMPLETED"];
      }
      listHospitalAPI(params, (list, error) => {
        if (!error) {
          setHospitalList(list?.list);
          if (currentPage === 1) {
            setTotalItems(list?.pageInfo?.totalItems ?? 0);
          }
        }
        setInitScreen(false);
      });
    } else {
      setInitScreen(false);
    }
  };
  const onExport = () => {
    setLoading(true);
    if (isReportRoute) {
      let params = {
        search: searchText || "",
        clientType: clientType?.value ?? null,
        branchId: isActiveClientsReport ? null : (branch?.id ?? null),
        month: requestMonth,
      };
      if (!isActiveClientsReport) {
        params.progressStatus = progressStatus?.value;
      }
      if (isActiveClientsReport) {
        params.rotaStatuses = ["ACTIVE", "COMPLETED"];
      }
      exportClientProgressReportAPI(params, (data, error) => {
        if (!error && data.fileUrl) {
          openLinkInNewTab(data.fileUrl);
        }
        setLoading(false);
      });
    } else {
      let params = {
        search: searchText,
        status: status?.value ?? location.state?.status?.value ?? ServerStatusType.active,
        clientType: clientType?.value ?? null,
        month: month || null,
      };
      exportClientAPI(params, (data, error) => {
        if (!error) {
          window.open(data.fileUrl, "default");
        }
        setLoading(false);
      });
    }
  };
  const onAddClick = () => {
    history.push(`${process.env.PUBLIC_URL}/add-client`);
  };
  const onImport = () => {
    setImportModalOpen(true);
  };
  const onMonthChange = (date) => {
    // Active Clients always keeps a month; clearing resets to current month
    const nextDate = !date && isActiveClientsReport ? moment(activeClientsMonth, "YYYY-MM-DD").toDate() : date || null;
    const monthValue = nextDate ? formatMonthParam(nextDate) : "";
    setSelectedMonth(nextDate);
    setMonth(monthValue);
    setCurrentPage(1);
    updateQueryParams({
      month: monthValue || undefined,
      page: 1,
    });
  };
  const updateQueryParams = (updates) => {
    const hashParams = {
      page: currentPage,
      branch: branch?.value,
      clientType: clientType?.value,
      agency: agency?.value,
      searchText: searchText,
      month: month,
      pathname: location.pathname,
    };

    // Add status or progressStatus based on route
    // Use value from updates if provided, otherwise use state
    // Only include in hash if it has a value (not undefined, null, or empty string)
    if (isReportRoute) {
      // Check if progressStatus is explicitly in updates (even if undefined/null)
      if ("progressStatus" in updates) {
        if (updates.progressStatus) {
          hashParams.progressStatus = updates.progressStatus;
        }
        // If updates.progressStatus is explicitly undefined/null/empty, don't add it (will be removed from URL)
      } else {
        // If not in updates, use state value
        if (progressStatus?.value) {
          hashParams.progressStatus = progressStatus.value;
        }
      }
    } else {
      // Check if status is explicitly in updates (even if undefined/null)
      if ("status" in updates) {
        if (updates.status) {
          hashParams.status = updates.status;
        }
        // If updates.status is explicitly undefined/null/empty, don't add it (will be removed from URL)
      } else {
        // If not in updates, use state value
        if (status?.value) {
          hashParams.status = status.value;
        }
      }
    }

    // Spread other updates (page, branch, clientType, etc.) after handling status/progressStatus
    Object.keys(updates).forEach((key) => {
      if (key !== "progressStatus" && key !== "status") {
        hashParams[key] = updates[key];
      }
    });
    updateHash(hashParams);
  };
  const onSearchChange = (searchText) => {
    setSearchText(searchText);
    setCurrentPage(1);
    updateQueryParams({
      searchText: searchText,
    });
  };
  const onBranchChange = (branch) => {
    setBranch(branch);
    setCurrentPage(1);
    updateQueryParams({
      branch: branch?.value,
    });
  };
  const onHospitalTypeChange = (clientType) => {
    setClientType(clientType);
    setCurrentPage(1);
    updateQueryParams({
      clientType: clientType?.value,
    });
  };
  const onAgencyChange = (agency) => {
    setAgency(agency);
    setCurrentPage(1);
    updateQueryParams({
      agency: agency?.value,
    });
  };
  const onStatusChange = (status) => {
    setStatus(status);
    setCurrentPage(1);
    updateQueryParams({
      status: status?.value,
      page: 1,
    });
  };
  const onProgressStatusChange = (progressStatus) => {
    setProgressStatus(progressStatus);
    setCurrentPage(1);
    // When "All" is selected, progressStatus is undefined, so explicitly pass undefined to remove it from URL
    const progressStatusValue = progressStatus?.value || undefined;
    updateQueryParams({
      progressStatus: progressStatusValue,
      page: 1,
    });
  };
  const onPageChanged = (page) => {
    setCurrentPage(page);
    updateQueryParams({
      page,
    });
  };
  return (
    <React.Fragment>
      <Head title={pageTitle} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="flex-wrap">
            <BlockHeadContent>
              <BlockTitle page>{pageTitle}</BlockTitle>
              <BlockDes className="text-soft">
                <p>You have total {totalItems} clients</p>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent className="ms-auto">
              <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-end">
                <span className="p-1">
                  <FormInput
                    labelGroupClass="m-0"
                    value={searchText ?? ""}
                    placeholder="Search Client"
                    onTextChange={onSearchChange}
                  />
                </span>
                <span className="p-1">
                  <FormDatePicker
                    selected={pickerMonth}
                    onChange={onMonthChange}
                    showMonthYearPicker
                    isClearable={!isActiveClientsReport}
                    maxDate={new Date()}
                    placeholderText="Select Month"
                  />
                </span>
                {!isActiveClientsReport && (
                  <span className="p-1">
                    <BranchDropDown
                      value={branch}
                      isClearable
                      isShowAll
                      className="w-225px"
                      onSelect={(e) => {
                        onBranchChange(e);
                      }}
                    />
                  </span>
                )}
                <span className="p-1">
                  <HospitalHomeCareDropDown
                    value={clientType}
                    placeholder={"Client Type"}
                    className="w-125px"
                    onSelect={(e) => {
                      onHospitalTypeChange(e);
                    }}
                  />
                </span>
                {!isReportRoute && (
                  <span className="p-1">
                    <AgencyDropdown
                      isShowAll={true}
                      className="w-150px"
                      value={agency}
                      onSelect={(e) => onAgencyChange(e)}
                    />
                  </span>
                )}
                {isReportRoute && !isActiveClientsReport && (
                  <span className="p-1">
                    <ReportStatusDropdown
                      value={progressStatus}
                      className="w-125px"
                      isShowAll={true}
                      onSelect={(e) => onProgressStatusChange(e)}
                    />
                  </span>
                )}
                {!isReportRoute && (
                  <span className="p-1">
                    <StatusActiveDropDown value={status} className="w-125px" onSelect={(e) => onStatusChange(e)} />
                  </span>
                )}
                {!isReportRoute && isAllowToAccess(UserPermissionType.client, UserActionType.import) && (
                  <span className="p-1">
                    <ImportExportButton title={"Import"} iconName={"arrow-down"} onClick={onImport} />
                  </span>
                )}
                {isAllowToAccess(UserPermissionType.client, UserActionType.export) && (
                  <span className="p-1">
                    <ImportExportButton title={"Export"} onClick={onExport} iconName={"arrow-up"} loading={loading} />
                  </span>
                )}
                {!isReportRoute && isAllowToAccess(UserPermissionType.client, UserActionType.add) && (
                  <span className="ps-1">
                    <ImportExportButton addButton title={"Add"} onClick={onAddClick} iconName={"plus"} />
                  </span>
                )}
                {isRowSelected && (
                  <span>
                    <MoreOptions
                      className="text-bg-light"
                      options={[
                        {
                          icon: "emails",
                          text: "Email",
                          action: () => setEmailModal(true),
                        },
                        {
                          icon: "chat",
                          text: "Sms",
                          action: () => {},
                        },
                        {
                          icon: "notes-alt",
                          text: "Note",
                          action: () => setNoteModal(true),
                        },
                      ]}
                    />
                  </span>
                )}
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewCard className={"hospital-list-table"}>
            <ReactDataTable
              data={hospitalList}
              columns={HospitalTableData(
                onEdit,
                onView,
                !isReportRoute || isActiveClientsReport,
                isReportRoute && !isActiveClientsReport,
              )}
              isAllowed={isCheckToList(UserPermissionType.client)}
              totalItemCount={totalItems}
              pageNum={currentPage}
              pagination
              onPageChanged={onPageChanged}
              onSort={(id) => {
                setSortId(id);
                setSortOrder(sortOrder === "desc" ? "asc" : "desc");
              }}
              onRowClicked={(row) => isAllowToAccess(UserPermissionType.client, UserActionType.detail) && onView(row)}
            />
          </PreviewCard>
        </Block>

        <SendEmailModal visible={emailModal} item={emailList} onClosed={() => setEmailModal(false)} />
        <AddNotes
          visible={noteModal}
          parents={selectedRowIds}
          type={NoteUserType.hospital}
          onClosed={() => setNoteModal(false)}
        />
      </Content>
      <LoadingComponent isLoading={initScreen} />
      <ImportFileModal
        isClientList={true}
        isOpen={importModalOpen}
        toggle={() => setImportModalOpen(!importModalOpen)}
        title="Clients"
        loadHospital={loadHospital}
      />
    </React.Fragment>
  );
};
export default HospitalList;
